import { useMutation } from '@tanstack/react-query';

import { MutationProps } from '~/types/mutation';
import { queryClient } from '~/utils';

import { model } from '..';

import { incomesQueryKey } from './consts';

export const useDeleteIncomeBulk = ({ onSuccess }: MutationProps) =>
  useMutation(model.bulkDelete, {
    onSuccess: () => {
      queryClient.invalidateQueries([incomesQueryKey]);
      onSuccess?.();
    },
  });
